import Temp from '@/courier/Temp'
export default class KerryQuickExpress extends Temp {

    static CODE = 'KRYQ'
    API_URL = this._VUE.$API_URL
    static API = {
      checkSameAddress: '/address/province/same'
    }
    static NAMETYPE = {
        BKKG_TO_BKKG: 1,
        BKKG_TO_UPC: 2,
        C_E_TO_BKKG: 3,
        C_E_TO_ALL: 4,
        C_E_SAME_PROVINCE: 5,
        N_NE_S_TO_BKKG: 6,
        N_TO_ALL: 7,
        NE_TO_ALL: 8,
        S_TO_ALL: 9,
        N_SAME_PROVINCE: 10,
        NE_SAME_PROVINCE: 11,
        S_SAME_PROVINCE: 12
    }
    static NAMEZONE = {
        BKKG: 1,
        C: 2,
        N: 3,
        S: 4,
        E: 5,
        NE: 6
    }

    constructor() {
        super( KerryQuickExpress.CODE )
    }

    async getZone( item ){
        let type , from , to
        let cross_price = 0
        let remote_area = 0

        // remote_area = super.checkRemoteArea( Number(item.toPostcode) )

        from = super.checkZone( item.fromPostcode )
        to = super.checkZone( item.toPostcode )
        type = await this.checkRateType( item , {from: from, to: to} )
        console.log( 'type', type )
        return {
            rate_type : type ,
            rate_remote_area : remote_area ,
            cross_price : cross_price
        }
    }
    async checkRateType( item, zone ){

        if( this.checkSameZoneBKKG(zone) )return KerryQuickExpress.NAMETYPE.BKKG_TO_BKKG
        if( zone.from === KerryQuickExpress.NAMEZONE.BKKG )
        return KerryQuickExpress.NAMETYPE.BKKG_TO_UPC
        const checkSameProvince = await this.checkSameProvinceByZone(zone, item)
        if( checkSameProvince !== false )return checkSameProvince

        if( [KerryQuickExpress.NAMEZONE.C, KerryQuickExpress.NAMEZONE.E].includes(zone.from) ){
            if( zone.to === KerryQuickExpress.NAMEZONE.BKKG )
            return KerryQuickExpress.NAMETYPE.C_E_TO_BKKG
            else return KerryQuickExpress.NAMETYPE.C_E_TO_ALL
        } 
        const zoneN_NE_S = [
            KerryQuickExpress.NAMEZONE.N,
            KerryQuickExpress.NAMEZONE.NE,
            KerryQuickExpress.NAMEZONE.S
        ]
        if( zoneN_NE_S.includes(zone.from) &&  zone.to === KerryQuickExpress.NAMEZONE.BKKG )
        return KerryQuickExpress.NAMETYPE.N_NE_S_TO_BKKG

        if( zone.from === KerryQuickExpress.NAMEZONE.N ) 
        return KerryQuickExpress.NAMETYPE.N_TO_ALL
        if( zone.from === KerryQuickExpress.NAMEZONE.NE ) 
        return KerryQuickExpress.NAMETYPE.NE_TO_ALL
        if( zone.from === KerryQuickExpress.NAMEZONE.S ) 
        return KerryQuickExpress.NAMETYPE.S_TO_ALL

        return -1

    }
    checkSameZoneBKKG( zone ){
        if( zone.from === KerryQuickExpress.NAMEZONE.BKKG && 
            zone.to === KerryQuickExpress.NAMEZONE.BKKG )return true
        else return false
    }
    async checkSameProvinceByZone( zone, postcodes ){
        if( zone.from !== zone.to )return false
        const sameProvince = await this.checkSameProvince( postcodes )
        if( !sameProvince )return false

        if( zone.from === KerryQuickExpress.NAMEZONE.C ||
            zone.from === KerryQuickExpress.NAMEZONE.E )
        return KerryQuickExpress.NAMETYPE.C_E_SAME_PROVINCE

        if( zone.from === KerryQuickExpress.NAMEZONE.N )
        return KerryQuickExpress.NAMETYPE.N_SAME_PROVINCE

        if( zone.from === KerryQuickExpress.NAMEZONE.S )
        return KerryQuickExpress.NAMETYPE.S_SAME_PROVINCE

        if( zone.from === KerryQuickExpress.NAMEZONE.NE )
        return KerryQuickExpress.NAMETYPE.NE_SAME_PROVINCE

        return false
        // let zones = {
        //     'C_E': this.checkSameZoneC_E,
        //     'N': this.checkSameZoneN,
        //     'S': this.checkSameZoneS,
        //     'NE': this.checkSameZoneNE
        // }
        // if( zones[nameZone](zone) === true )return true
        // else return false
    }
    async checkSameProvince( item ){
      const check = await this._VUE.$http.get( 
        this.API_URL + KerryQuickExpress.API.checkSameAddress, 
        {
        headers: {
          Token: localStorage.getItem("access_token")
        },
        params: {
            from_postcode: item.fromPostcode,
            to_postcode: item.toPostcode,
        }
      })

      try{
        const _check = check.data.data
        if( _check.status === false ) throw( _check.msg )
        else if( _check.msg === 'not within same province' )return false
        else return true
      }catch( err ){
        console.info( err )
        return false
      }

    }
    checkWeight( courierRates , item, validate ){
        item.index = courierRates.findIndex(rate => {
            return item.weight >= rate.min && item.weight <= rate.max
        })

        return super.checkRules( item, validate );
        return {
            index: item.index
        } 
    }
    checkDimension( dimensionCourier , item , validate ){
        return super.checkCourierDimension( dimensionCourier , item , validate );
    }

}